"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BROADCAST_SET_SESSION_STATE = void 0;
var BROADCAST_SET_SESSION_STATE = exports.BROADCAST_SET_SESSION_STATE = 'BROADCAST_SET_SESSION_STATE';